import React, { useState } from "react";
import Controls from "../../../components/controls/control";
import QuizList from "./QuizList";
import { useSelector } from "react-redux";
import {
  useGetAssignmentWithVideoIdQuery,
  useGetQuizWithVideoIdQuery,
} from "../../../features/Student/Quiz/quizApi";
import Loading from "../../../components/Ui/Loading";
import Error from "../../../components/Ui/Error";

export default function Quiz() {
  // *****************************************************DECLARATION START******************************************************************************
  const { videoId, videoTitle } = useSelector((state) => state.coursePlayer);
  const {
    data: quizzes,
    isLoading,
    isError,
    isSuccess,
  } = useGetQuizWithVideoIdQuery(videoId);

  const [selectedOptions, setSelectedOptions] = useState(false);
  // *****************************************************DECLARATION END******************************************************************************
  // *****************************************************useEffect START******************************************************************************
  // *****************************************************useEffect END******************************************************************************
  // *****************************************************HANDLE START******************************************************************************
  function handleOptionChange(event) {
    const { name, checked } = event.target;
    setSelectedOptions({
      ...selectedOptions,
      [name]: checked,
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    console.log("selectedOptions", selectedOptions);
  }

  // *****************************************************HANDLE END******************************************************************************
  // *****************************************************Decided which part render START******************************************************************************
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = (
      <Error
        header="Error !!"
        message="System error contact with administrator"
      />
    );
  } else if (!isLoading && !isError && quizzes?.length === 0) {
    content = <Error header="" message="No Quiz available" />;
  } else if (!isLoading && !isError && quizzes?.length > 0) {
    content = quizzes.map((row, index) => (
      <QuizList
        row={row}
        key={`${row?.id}_${index}`}
        selectedOptions={selectedOptions}
        handleOptionChange={handleOptionChange}
        handleSubmit={handleSubmit}
      />
    ));
  }
  // *****************************************************Decided which part render END******************************************************************************

  return (
    <>
      <div className="mb-8">
        <h1 className="text-2xl font-bold">Quizzes for "{videoTitle}"</h1>
        <p className="text-sm text-slate-200">Each question contains 5 Mark</p>
      </div>
      <div className="space-y-8 ">{content}</div>

      <Controls.Button
        text={"Submit"}
        type={"submit"}
        className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 "
      />
    </>
  );
}
